
import { computed, defineComponent, PropType, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router/composables";

export default defineComponent({
  name: "ContentHubNavItem",
  props: {
    navItem: {
      type: Object as PropType<ContentHubs.NavItem>,
      required: true,
    },
    nested: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const expanded = ref(location.pathname.match(props.navItem.path) !== null);
    const expandable = computed((): boolean => props.navItem.content_routes?.length > 0);
    const router = useRouter();
    const route = useRoute();
    const toggleExpand = () => {
      if (!expandable.value) return;
      expanded.value = !expanded.value;
    };

    const nestedContentRoutes = computed((): ContentHubs.NavItem[] => props.navItem.content_routes);
    const redirectToContentHub = () => router.push(props.navItem.path);

    const borderClass = computed((): string => {
      if (expandable.value && expanded.value && !props.nested) return "";

      return props.nested ? "border-left" : "border-bottom";
    });
    const paddingClass = computed((): string => (props.nested ? "ml-2 pl-3" : ""));
    const active = ref(route.path === props.navItem.path);

    // this shouldn't be necessary and `active` as a computed property is supposed to cover this, but it doesn't
    watch(
      () => route.path,
      async (newPath) => (active.value = newPath === props.navItem.path)
    );

    return {
      active,
      expanded,
      expandable,
      borderClass,
      paddingClass,
      nestedContentRoutes,
      redirectToContentHub,
      toggleExpand,
    };
  },
});
